import { render, staticRenderFns } from "./couponDes.vue?vue&type=template&id=6b5f1763&scoped=true"
import script from "./couponDes.vue?vue&type=script&lang=js"
export * from "./couponDes.vue?vue&type=script&lang=js"
import style0 from "./couponDes.vue?vue&type=style&index=0&id=6b5f1763&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5f1763",
  null
  
)

export default component.exports